import React from 'react';

const CardOwner = () => {
  return <div>CardOwner</div>;
};

export default CardOwner;
